import { useContext } from 'react';
import { ComponentMethodsContext } from 'js/components/hocs/withComponent/context';

export const useComponentMethods = () => useContext(ComponentMethodsContext);
